import { writable } from 'svelte/store';

export const issueState = writable([]);